export enum QueryKey {
  USER = "user",
  EXPERIMENTS = "experiments",
  NETWORK_INFO = "network-info",
  SB_CREDENTIALS = "sb-credentials",
  COACHING_GROUPS = "coaching-groups",
  COACHING_SUBSCRIPTION = "coaching-subscription",
  CLIENT_QUESTIONNAIRES = "client-questionnaires",
  ALL_BILLING_PERIODS = "all-billing-periods",
  SESSION_BILLING_PERIODS = "session-billing-periods",
  SESSION_BOOKINGS = "session-bookings",
  UPCOMING_SESSIONS = "upcoming-sessions",
  SESSION_BOOKING = "session-booking",
  PARENT_TRAINING_DATA_TASKS = "parent-training-data-tasks",
  INCIDENTS = "incidents",
  UNREAD_INCIDENTS = "unread-incidents",
  COACHING_SUBSCRIPTIONS = "coaching-subscriptions",
  DEACTIVATED_COACHING_GROUPS = "deactivated-coaching-groups",

  QUESTS = "quests",
  SCHEDULED_MESSAGES = "scheduled-messages",
  FAMILY = "family",
  COACH_TODOS = "coach-todos",
  COACH_DIRECT_REPORTS = "coach-direct-reports",
  USER_SMS_STATUS = "user-sms-status",
}
